import { Reducer, AnyAction } from 'redux';
import { WorkItemState } from '../../Models/WorkItemState';

export interface FilterState {
  selectedRequestorItems: string[];
  selectedStatusItems: string[];
  selectedAssignedToItems: string[];
  globalSearchFilterText: string;
  filterText: string;
  workItemStates: WorkItemState[];
  toShowCovidRecordsOnly: boolean;
  toShowTechnicalFeedbackRecords: boolean;
  disabledClearFilterButtons: boolean;
}

export const reducer: Reducer<FilterState> = (
  oldState: FilterState,
  action: AnyAction
): FilterState => {
  let newState: FilterState;
  switch (action.type) {
    case FilterActions.FILTER_TEXT:
      newState = {
        ...oldState,
        filterText: action.payload,
      };
      break;
    case FilterActions.FILTER_STATES:
      newState = {
        ...oldState,
        selectedStatusItems: action.payload,
      };
      break;
    case FilterActions.FILTER_ASSIGNED_USERS:
      newState = {
        ...oldState,
        selectedAssignedToItems: action.payload,
      };
      break;
    case FilterActions.FILTER_REQUESTOR:
      newState = {
        ...oldState,
        selectedRequestorItems: action.payload,
      };
      break;
    case FilterActions.FILTER_COVID19:
      newState = {
        ...oldState,
        toShowCovidRecordsOnly: action.payload,
      };
      break;
    case FilterActions.FILTER_TECHNICALFEEDBACK:
      newState = {
        ...oldState,
        toShowTechnicalFeedbackRecords: action.payload,
      };
      break;
    case FilterActions.FILTER_GLOBALSEARCH:
      newState = {
        ...oldState,
        globalSearchFilterText: action.payload,
      };
      break;
    case FilterActions.RESET_GLOBALSEARCH:
      newState = {
        ...oldState,
        globalSearchFilterText: '',
      };
      break;
    case FilterActions.FILTER_RESET:
      newState = {
        ...oldState,
        disabledClearFilterButtons: true,
        filterText: '',
        selectedAssignedToItems: [],
        selectedRequestorItems: [],
        selectedStatusItems: [],
        toShowCovidRecordsOnly: false,
        toShowTechnicalFeedbackRecords: false,
      };
      break;
    default:
      return oldState === undefined ? defaultFilterState : oldState;
  }
  return newState;
};

export const FilterActions = {
  FILTER_ASSIGNED_USERS: 'FILTER_ASSIGNED_USERS',
  FILTER_REQUESTOR: 'FILTER_REQUESTOR',
  FILTER_STATES: 'FILTER_STATES',
  FILTER_TEXT: 'FILTER_TEXT',
  FILTER_COVID19: 'FILTER_COVID19',
  FILTER_RESET: 'FILTER_RESET',
  FILTER_TECHNICALFEEDBACK: 'FILTER_TECHNICALFEEDBACK',
  FILTER_GLOBALSEARCH: 'FILTER_GLOBALSEARCH',
  RESET_GLOBALSEARCH: 'RESET_GLOBALSEARCH',
};

export const defaultFilterState: FilterState = {
  filterText: '',
  globalSearchFilterText: '',
  disabledClearFilterButtons: true,
  selectedAssignedToItems: [],
  selectedRequestorItems: [],
  selectedStatusItems: [],
  toShowCovidRecordsOnly: false,
  toShowTechnicalFeedbackRecords: false,
  workItemStates: [],
};

//#region FILTERS
export const filterByAssingedUsers = (payload: string[]) => {
  return {
    type: FilterActions.FILTER_ASSIGNED_USERS,
    payload,
  };
};

export const filterStoreByAssingedUsers = (payload: string[]) => (dispatch: any) => {
  dispatch({
    type: FilterActions.FILTER_ASSIGNED_USERS,
    payload,
  });
};

export const filterByRequestor = (payload: string[]) => {
  return {
    type: FilterActions.FILTER_REQUESTOR,
    payload,
  };
};

export const filterByState = (payload: string[]) => {
  return {
    type: FilterActions.FILTER_STATES,
    payload,
  };
};

export const filterByText = (payload: string) => {
  return {
    type: FilterActions.FILTER_TEXT,
    payload,
  };
};

export const filterCovid19 = (payload: boolean) => {
  return {
    type: FilterActions.FILTER_COVID19,
    payload,
  };
};

export const updateGlobalSearchInput = (payload: any) => (dispatch: any) => {
  dispatch({
    type: FilterActions.FILTER_GLOBALSEARCH,
    payload,
  });
};

export const resetGlobalSearchInput = (payload: any) => (dispatch: any) => {
  dispatch({
    type: FilterActions.RESET_GLOBALSEARCH,
    payload,
  });
};

export const filterTechnicalFeedback = (payload: boolean) => {
  return {
    type: FilterActions.FILTER_TECHNICALFEEDBACK,
    payload,
  };
};

export const resetFilter = () => {
  return {
    type: FilterActions.FILTER_RESET,
  };
};
//#endregion
